import React from "react";
import { useAlert } from "../context/AlertContext";
import "../css/Alert.css";

const Alert = () => {
  const { alert } = useAlert();

  if (!alert.visible) return null;

  return (
    <div className={`alert ${alert.type}`}>
      {alert.message}
    </div>
  );
};

export default Alert;
